import { render } from "./CustomizationSubmitToRetailerDialog.vue?vue&type=template&id=f04893da&scoped=true"
import script from "./CustomizationSubmitToRetailerDialog.vue?vue&type=script&lang=js"
export * from "./CustomizationSubmitToRetailerDialog.vue?vue&type=script&lang=js"

import "./CustomizationSubmitToRetailerDialog.vue?vue&type=style&index=0&id=f04893da&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f04893da"]])

export default __exports__